/**
 * @author      yewon@zumper.com (Yewon Lee)
 * @copyright   Copyright (c) 2018, Zumper
 * @description RefineMessage
 */

import { DEFAULT_SEND_ERROR_MSG } from '../../../constants/message'

const refineMessage = (err) => {
  try {
    const fields = {
      message: 'Message',
    }
    // payload comes back as serialized JSON
    const payload = JSON.parse(err.config.body)
    const { field } = err.data
    const input = payload[field]

    let refinedMsg = fields[field] || field

    if (input) {
      refinedMsg += ` '${input}'`
    }
    refinedMsg += ' is not valid'
    return refinedMsg
  } catch (e) {
    return DEFAULT_SEND_ERROR_MSG
  }
}

export default refineMessage
